import BotMessageTypeEnum from "./BotMessageTypeEnum";
import { MessageEntity } from "./MessageEntity";

export class NotificationEntity extends MessageEntity{
    constructor(public watermark: number,
                public from: string,
                public conversationId: string,
                public text: string,
                public time: string,
                public id: string,
                public seen: boolean = false,
                public toShow: boolean = true){
        super(watermark,BotMessageTypeEnum.NOTIFICATION,from,conversationId,text,time)
    }
} 